import { Build } from '@stencil/core';
export const isBrowser = () => Build.isBrowser;
export function isMobile() {
  if (!isBrowser())
    return true;
  const desktopBreakpoint = 980;
  return window.innerWidth < desktopBreakpoint;
}
